import React, { useState, useEffect } from 'react';
import Enumerable from 'linq';

//MUI Components
import { Autocomplete, TextField } from '@mui/material';

//Utilities
import { obtenerUbicacionNivel3 } from './UbicacionesFunctions';

export const SelectUbicacionNivel3 = ({ textLabel, textSinOpciones, testSeleccione, setIdElemento, idElemento = '00000000-0000-0000-0000-000000000000', idElementoPadre = '00000000-0000-0000-0000-000000000000', sesionUsuario, dispatch }) => {

    const [elemento, setElemento] = React.useState({ locLocation3Id: '00000000-0000-0000-0000-000000000000', locName: '' });
    const [listadoElementos, setListadoElementos] = useState([]);

    const LoadProperties = async () => {
        const listadoTemp = await obtenerUbicacionNivel3('', idElementoPadre, sesionUsuario, dispatch);
        setListadoElementos([{ locLocation3Id: '00000000-0000-0000-0000-000000000000', locName: testSeleccione }, ...listadoTemp]);
        cargarElemento(listadoTemp);
    };

    useEffect(() => {
        LoadProperties();
    }, [idElementoPadre]);

    useEffect(() => {
        cargarElemento(listadoElementos);
    }, [idElemento]);

    useEffect(() => {
        setIdElemento(elemento === null || elemento === undefined ? '00000000-0000-0000-0000-000000000000' : elemento.locLocation3Id);
    }, [elemento?.locLocation3Id]);

    const cargarElemento = (listado) => {
        if (idElemento !== '00000000-0000-0000-0000-000000000000') {
            if (listado.length > 0) {
                if (Enumerable.from(listado).any(x => x.locLocation3Id.toLowerCase() === idElemento.toLowerCase())) {
                    setElemento({ locLocation3Id: idElemento, locName: Enumerable.from(listado).first(x => x.locLocation3Id.toLowerCase() === idElemento.toLowerCase()).locName });
                } else {
                    setElemento({ locLocation3Id: '00000000-0000-0000-0000-000000000000', locName: testSeleccione });
                }
            } else {
                setElemento({ locLocation3Id: '00000000-0000-0000-0000-000000000000', locName: testSeleccione });
            }
        } else {
            setElemento({ locLocation3Id: '00000000-0000-0000-0000-000000000000', locName: testSeleccione });
        }
    };

    const ingresarValoresMemoriaAuto = (event, newValue) => {
        setElemento(newValue);
    };

    return (
        <Autocomplete fullWidth
            disabled={listadoElementos.length === 1}
            noOptionsText={textSinOpciones}
            value={elemento}
            id={textLabel}
            name='UbicacionNivel3-Element'
            options={listadoElementos}
            onChange={ingresarValoresMemoriaAuto}
            getOptionLabel={(option) => option.locName}
            getOptionDisabled={(option) => option.locLocation3Id === '00000000-0000-0000-0000-000000000000'}
            renderInput={(params) => <TextField name='label' {...params} label={textLabel} />}
        />
    )
}